import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Cpu, Globe, FileCheck } from 'lucide-react';

const PILLARS = [
  { icon: Lock,      label: 'Encrypted in transit & at rest' },
  { icon: Cpu,       label: 'Private LLMs · no training on your data' },
  { icon: Globe,     label: 'GCC data residency available' },
  { icon: FileCheck, label: 'SOC 2 Type I underway' },
];

const TrustBar = () => {
  return (
    <section className="relative py-14 border-y border-white/[0.05]">
      <div className="container-prose">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center text-[10.5px] font-semibold tracking-[0.16em] uppercase text-ink-faint/70 mb-8"
        >
          Built for the standards your compliance team will ask about
        </motion.p>
        <div className="grid grid-cols-2 gap-y-6 gap-x-4 md:flex md:items-center md:justify-between md:gap-x-6 md:max-w-5xl md:mx-auto">
          {PILLARS.map(({ icon: Icon, label }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-center gap-2.5 text-canvas-white/80"
            >
              <Icon size={15} className="text-amber flex-shrink-0" strokeWidth={1.6} />
              <span className="text-[12.5px] tracking-tight">{label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
